import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto bg-white p-6 rounded-lg shadow-md">
       

        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">EventIQ - Terms of Use</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8 text-center">Last updated: 12/11/2025</p>
           {/* Developer Information */}
        <div className="mb-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <h2 className="text-lg font-semibold text-blue-800 mb-3">Developer Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-gray-700">
              <div>
                <span className="font-medium">Developer:</span> Divya HM
              </div>
              <div>
                <span className="font-medium">Company:</span> Binalogy
              </div>
              <div>
                <span className="font-medium">Email:</span> divya@binalogy.in
              </div>
              <div>
                <span className="font-medium">Location:</span> Bangalore, India
              </div>
            </div>
          </div>
          {/* Description of the Service */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">1. Description of the Service</h2>
            <p className="text-gray-600 mb-4">
              EventIQ is a mobile application that provides tools for event creation,
              QR-based invitations, RSVP tracking, media sharing, and sustainability
              analytics to help hosts organize and manage events efficiently.
            </p>
            <p className="text-gray-600 mb-4">
              Features may include:
            </p>
            <ul className="list-disc list-inside text-gray-600 ml-4">
              <li>Creating and managing event details</li>
              <li>Sending and scanning QR invitations</li>
              <li>Tracking RSVPs and attendance</li>
              <li>Uploading and sharing event media</li>
              <li>Providing sustainability insights such as food wastage reduction metrics</li>
            </ul>
            <p className="text-gray-600">
              We may modify, enhance, or discontinue features at any time.
            </p>
          </section>

          {/* Acceptance of Terms and Changes */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">2. Acceptance of Terms and Changes</h2>
            <p className="text-gray-600 mb-4">
              By downloading, installing, or using EventIQ, you agree to these Terms of Use.
              If you do not agree, you must uninstall and stop using the app.
            </p>
            <p className="text-gray-600">
              We may modify these Terms from time to time. Significant changes will be
              communicated via in-app notification or email. Continued use after
              changes means you accept the updated Terms.
            </p>
          </section>

          {/* Eligibility; Account Creation */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">3. Eligibility; Account Creation</h2>
            <p className="text-gray-600 mb-4">
              You must be at least 13 years old to use the App (or 16 in the EU).
            </p>
            <p className="text-gray-600 mb-4">
              You may need to create an account by providing accurate personal
              information such as name, email, or phone number.
            </p>
            <p className="text-gray-600 mb-4">
              You are responsible for maintaining the confidentiality of your login
              credentials and all activity that occurs under your account.
            </p>
            <p className="text-gray-600">
              If we believe you have provided false information or violated these
              Terms, your account may be suspended or terminated.
            </p>
          </section>

          {/* Permitted Use */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">4. Permitted Use</h2>
            <p className="text-gray-600 mb-4">
              You are granted a limited, non-exclusive, non-transferable, revocable
              license to use EventIQ for personal or authorized event management
              purposes.
            </p>
            <p className="text-gray-600">
              You may not use the App for commercial resale or any unlawful purpose.
            </p>
          </section>

          {/* Prohibited Conduct */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">5. Prohibited Conduct</h2>
            <p className="text-gray-600 mb-4">
              You agree not to:
            </p>
            <ul className="list-disc list-inside text-gray-600 ml-4 mb-4">
              <li>Reverse-engineer, decompile, or attempt to extract the source code</li>
              <li>Upload or share offensive, illegal, or infringing content</li>
              <li>Use automated systems (bots/scrapers) to collect data</li>
              <li>Interfere with app functionality or security</li>
              <li>Impersonate another person or misrepresent your affiliation</li>
              <li>Circumvent app restrictions or misuse invitation tools</li>
            </ul>
            <p className="text-gray-600">
              Violation may result in suspension or legal action.
            </p>
          </section>

          {/* User Content and Media */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">6. User Content and Media</h2>
            <p className="text-gray-600 mb-4">
              You retain ownership of the content you upload, including photos,
              videos, and event information.
            </p>
            <p className="text-gray-600 mb-4">
              By uploading, you grant EventIQ a worldwide, non-exclusive, royalty-free
              license to use, host, and display your content only as necessary to
              provide app functionality (e.g., displaying event photos to invited guests).
            </p>
            <p className="text-gray-600">
              You represent that your content does not infringe on third-party rights.
            </p>
          </section>

          {/* Permissions */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">7. Permissions</h2>
            <p className="text-gray-600 mb-4">
              To provide certain features, EventIQ may request access to:
            </p>
            <ul className="list-disc list-inside text-gray-600 ml-4 mb-4">
              <li><strong>Contacts:</strong> To send invitations</li>
              <li><strong>Camera:</strong> To scan QR codes</li>
              <li><strong>Photos/Videos:</strong> To upload event media</li>
              <li><strong>Location:</strong> For event venue mapping</li>
            </ul>
            <p className="text-gray-600">
              You can deny permissions, but doing so may limit app functionality.
            </p>
          </section>

          {/* Intellectual Property */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">8. Intellectual Property</h2>
            <p className="text-gray-600">
              All intellectual property related to EventIQ—including its software,
              design, logo, and analytics tools—is owned by Binalogy.
              You may not reproduce, distribute, or create derivative works without
              prior written consent.
            </p>
          </section>

          {/* Push Notifications and Communications */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">9. Push Notifications and Communications</h2>
            <p className="text-gray-600">
              EventIQ may send notifications related to event updates, RSVP reminders,
              or feature updates.
              You can control notification preferences through your device settings.
            </p>
          </section>

          {/* Third-Party Services and Links */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">10. Third-Party Services and Links</h2>
            <p className="text-gray-600">
              The App may integrate or link to third-party platforms (e.g., maps,
              social media, or analytics).
              Your use of those services is governed by their respective terms and
              privacy policies.
              We are not responsible for third-party content or conduct.
            </p>
          </section>

          {/* Privacy */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">11. Privacy</h2>
            <p className="text-gray-600 mb-4">
              Your privacy is important to us.
            </p>
            <p className="text-gray-600 mb-4">
              Our <a href="/privacy" className="text-blue-600 hover:text-blue-800 underline">Privacy Policy</a> explains how we collect, use, and store your information.
            </p>
            <p className="text-gray-600">
              By using EventIQ, you consent to the collection and use of your data as described there.
            </p>
          </section>

          {/* Disclaimer of Warranties */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">12. Disclaimer of Warranties</h2>
            <p className="text-gray-600">
              EventIQ is provided "as is" and "as available."
              We make no guarantees about uninterrupted or error-free operation, nor
              about the accuracy of analytics or data insights.
              You use the App at your own risk.
            </p>
          </section>

          {/* Limitation of Liability */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">13. Limitation of Liability</h2>
            <p className="text-gray-600 mb-4">
              To the maximum extent permitted by law, Binalogy and its affiliates are
              not liable for any indirect, incidental, consequential, or punitive
              damages arising from your use of the App.
            </p>
            <p className="text-gray-600">
              Our total liability for direct damages will not exceed INR 5,000 or the
              total amount paid by you in the 6 months preceding the claim, whichever
              is lower.
            </p>
          </section>

          {/* Indemnification */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">14. Indemnification</h2>
            <p className="text-gray-600">
              You agree to indemnify and hold harmless Binalogy, its affiliates, and
              employees from any claim or demand arising from your misuse of the App,
              breach of these Terms, or violation of applicable laws.
            </p>
          </section>

          {/* Termination and Suspension */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">15. Termination and Suspension</h2>
            <p className="text-gray-600 mb-4">
              We may suspend or terminate your account at our discretion for
              violations of these Terms, suspected fraudulent activity, or inactivity.
            </p>
            <p className="text-gray-600">
              You may delete your account at any time by contacting support or through
              app settings.
            </p>
          </section>

          {/* Modifications to the App */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">16. Modifications to the App</h2>
            <p className="text-gray-600 mb-4">
              We may update, modify, or discontinue parts of EventIQ without prior notice.
            </p>
            <p className="text-gray-600">
              You are responsible for keeping the app updated to ensure compatibility
              and functionality.
            </p>
          </section>

          {/* Export Compliance */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">17. Export Compliance</h2>
            <p className="text-gray-600">
              You agree to comply with applicable export laws when using EventIQ and
              not to distribute it in violation of such laws.
            </p>
          </section>

          {/* Governing Law and Dispute Resolution */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">18. Governing Law and Dispute Resolution</h2>
            <p className="text-gray-600 mb-4">
              These Terms are governed by the laws of India.
            </p>
            <p className="text-gray-600 mb-4">
              Any disputes will be subject to the exclusive jurisdiction of the courts
              in <strong>Bangalore, India</strong>.
            </p>
            <p className="text-gray-600">
              Before initiating any legal action, you agree to attempt to resolve
              disputes informally by contacting us at <strong>divya@binalogy.in</strong>.
            </p>
          </section>

          {/* Notices */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">19. Notices</h2>
            <p className="text-gray-600 mb-4">
              We may send notices via email, in-app messages, or by posting them on
              our website.
            </p>
            <p className="text-gray-600">
              Legal notices to EventIQ should be sent to <strong>divya@binalogy.in</strong>.
            </p>
          </section>

          {/* Severability; No Waiver */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">20. Severability; No Waiver</h2>
            <p className="text-gray-600 mb-4">
              If any provision is found invalid or unenforceable, the remaining
              provisions remain in effect.
            </p>
            <p className="text-gray-600">
              Failure to enforce a right or provision does not constitute a waiver.
            </p>
          </section>

          {/* Assignment */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">21. Assignment</h2>
            <p className="text-gray-600 mb-4">
              We may assign our rights or obligations under these Terms to a successor
              entity.
            </p>
            <p className="text-gray-600">
              You may not assign your rights without prior written consent.
            </p>
          </section>

          {/* Feedback and Improvements */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">22. Feedback and Improvements</h2>
            <p className="text-gray-600">
              If you provide feedback or suggestions, you grant us a perpetual,
              royalty-free right to use and implement them without obligation.
            </p>
          </section>

          {/* Relationship with App Stores */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">23. Relationship with App Stores</h2>
            <p className="text-gray-600 mb-4">
              If you download EventIQ from Google Play or the App Store, you must
              comply with their respective terms.
            </p>
            <p className="text-gray-600">
              Google and Apple are not responsible for app operation or support.
            </p>
          </section>

          {/* Entire Agreement */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">24. Entire Agreement</h2>
            <p className="text-gray-600">
              These Terms, together with the Privacy Policy and any referenced
              documents, form the complete agreement between you and Binalogy
              regarding EventIQ.
            </p>
          </section>

          {/* Contact Information */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">25. Contact Information</h2>
            <p className="text-gray-600 mb-2">
              For support or questions, contact us at:
            </p>
            <p className="text-gray-600 mb-2">
              📧 <strong>Email:</strong> divya@binalogy.in
            </p>
            <p className="text-gray-600">
              📍 <strong>Address:</strong> Bangalore, India
            </p>
          </section>

         
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;